export interface FeatureItem {
  title: string;
  text: string;
  icon: string;
}

export interface ServiceItem {
  title: string;
  text: string;
  image: string;
  icon: string;
}

export interface ServiceCardItem {
  title: string;
  text: string;
  image: string;
  icon: string;
}

export interface DifferentRow {
  label: string;
  ppc: boolean;
  typical: boolean;
}

export interface Provider {
  firstName: string;
  lastName: string;
  credential: string;
  image: string;
  href: string;
}

export interface ReviewItem {
  name: string;
  date: string;
  text: string;
  avatar: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface ResourceItem {
  title: string;
  text: string;
  image: string;
  ctaLabel: string;
  ctaHref: string;
}

export const appointmentUrl =
  "https://service.emedpractice.com/newappt/#/?RandomKey=x1ygOQdSqc4";

export const patientPortalUrl =
  "https://patientportal.emedpractice.com/patientportal/#/login";

export const resourceNavLinks = [
  { label: "Shop", href: "#shop" },
  { label: "Blogs", href: "#resources" },
  { label: "Forms", href: "#resources" },
  { label: "Insurance", href: "#insurance" },
  { label: "Jobs & Careers", href: "#contact" },
  { label: "Leave A Review", href: "#reviews" },
];

export const locationNavLinks = [
  { label: "Boca Raton", href: "#locations" },
  { label: "Delray", href: "#locations" },
  { label: "Hallandale", href: "#locations" },
];

export const asSeenOnLogos = [
  {
    name: "Fox News",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a03ff0183c4c654bcd463_Fox%20News.webp",
  },
  {
    name: "Digital Journal",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a10abe5ca8ea4ec8749d6_Digital%20Journal.webp",
  },
  {
    name: "USA Today",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a10ab67fec8fd7d41db23_USA%20Today.webp",
  },
  {
    name: "CBS",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a10abc633a123f5f9c885_CBS.webp",
  },
  {
    name: "NBC",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a10abe904f345561dc239_NBC.webp",
  },
  {
    name: "ABC",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/650a10aba8a4295ca9cc348d_ABC.webp",
  },
];

export const portalFeaturesLeft: FeatureItem[] = [
  {
    title: "Request an Appointment",
    text: "Seamless, real-time booking with skilled doctors at various locations.",
    icon: "ri-calendar-check-line",
  },
  {
    title: "Get Yearly Exam Reminders",
    text: "Personalized health reminders for essential check-ups, right to your inbox.",
    icon: "ri-notification-3-line",
  },
  {
    title: "View and Make Payments",
    text: "Hassle-free, secure and transparent online payments for seamless bill management.",
    icon: "ri-bank-card-line",
  },
];

export const portalFeaturesRight: FeatureItem[] = [
  {
    title: "Access Lab Results With Ease",
    text: "Stay informed with quick and secure lab results on our intuitive patient portal.",
    icon: "ri-flask-line",
  },
  {
    title: "Share Clinical Documents",
    text: "Easily access and share clinical documents for a collaborative well-being.",
    icon: "ri-folder-shared-line",
  },
  {
    title: "Securely Message Care Team",
    text: "Securely message your care team for personalized healthcare communication.",
    icon: "ri-chat-3-line",
  },
];

export const phoneImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/6490787cbefb5c4f121ee9e4_Phone%20FaceTime.webp";

export const aboutImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c8997bedef02580e1f02b_About.webp";

export const experienceImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c8a42e08413fcf960538a_Personal.webp";

export const teamImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c8a4f39ed0cf676c1efb9_Team.webp";

export const stethoscopeImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648cc99546097276fae1a8f0_Stethoscope.webp";

export const featuredServices: ServiceItem[] = [
  {
    title: "Same-Day Urgent Appointment",
    text: "Prompt access to urgent care services is crucial for addressing health concerns and ensuring timely resolutions for better well-being.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64ad9aba3d0c88a609537a41_Same%20Day%20Appointment.webp",
    icon: "ri-hospital-line",
  },
  {
    title: "Lab Testing",
    text: "Convenience of in-house lab testing at PPC, where timely results enable faster diagnosis, personalized treatment, and streamlined healthcare.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64ad9a891ee474edaf64ad96_On%20Site%20Labs.webp",
    icon: "ri-temp-hot-line",
  },
  {
    title: "In-House Ultrasound",
    text: "Discover the advantage of having an in-house ultrasound available at PPC, for enhanced treatment planning for optimal healthcare outcomes.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64ad9a737ac504f48317fccb_Ultrasound.webp",
    icon: "ri-heart-pulse-line",
  },
  {
    title: "Tele-Health Appointment",
    text: "Embrace the convenience of tele-health services, connecting you with medical experts virtually for accessible healthcare from your space.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64cd448a3c6ebe483e1fdb79_Telehealth.webp",
    icon: "ri-smartphone-line",
  },
  {
    title: "24/7 On Call Provider",
    text: "Experience peace of mind with our 24/7 on-call provider, offering around-the-clock medical support and care when you need it most.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64ad9ac777214b73bd1170e4_Prescription%20Management.webp",
    icon: "ri-customer-service-2-line",
  },
  {
    title: "IV Infusion",
    text: "Discover the benefits of IV infusion, providing rapid delivery of essential nutrients and medications, while optimizing your overall health.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64cd4730b5da26b60a31444a_IV%20Infusion.webp",
    icon: "ri-medicine-bottle-line",
  },
];

export const serviceCards: ServiceCardItem[] = [
  {
    title: "Same/Next Day Urgent Appointments",
    text: "Same-day and next-day appointments available at all three PPC locations — Boca Raton, Delray Beach, and Hallandale Beach. No weeks-long waits. When you need care, we see you.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64ad9818c710db594a5045be_Same%20Day%20Appointment.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2f37306f684a8354b23ce_line_hospital.svg",
  },
  {
    title: "On-Site Lab Testing",
    text: "In-house lab testing at PPC means results the same day — no separate facility, no extra trip. Blood work, urinalysis, cultures, HbA1c, lipid panels, and more, right at your appointment.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2e7e736adffb8a7f45866_On%20Site%20Labs.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2f7ee3ff24791d750b2b5_line_thermometer-3.svg",
  },
  {
    title: "In-House Ultrasound",
    text: "On-site ultrasound at PPC — abdominal, thyroid, vascular, and more — performed and reviewed at your appointment. No referral to an outside imaging center needed for most studies.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2ed250506150fe13c0a7a_Ultrasound.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2fee3ba7cdf6c38fba666_line_bed-left.svg",
  },
  {
    title: "Tele-Health Appointment",
    text: "The convenience of tele-health services, connecting you with medical experts virtually for accessible healthcare.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64ad991bbd7b580e6d1181aa_Telehealth.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2f86f06f684a835519004_line_mobile-phone.svg",
  },
  {
    title: "24/7 On Call Provider",
    text: "Find tranquility with our 24/7 on-call provider, delivering constant medical support when you need it the most.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64d10ecfde937167e332a7ef_24-7%20On%20Call%20Provider.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64d10cd59e76c09d99d8932c_line_headset-alt.svg",
  },
  {
    title: "IV Infusion Therapy",
    text: "Discover the benefits of IV infusion, providing essential nutrients and medications, while optimizing your health.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2ee06ed964d6f1bc036e2_IV%20Infusion.webp",
    icon: "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64a2f3370b1489126280e9e1_line_iv-bag-3.svg",
  },
];

export const differentRows: DifferentRow[] = [
  { label: "Family owned & operated for 35+ years", ppc: true, typical: false },
  {
    label: "Same-day to next-day urgent appointments",
    ppc: true,
    typical: false,
  },
  {
    label: "Over 18 award-winning providers & specialists",
    ppc: true,
    typical: false,
  },
  {
    label: "Integrated in-house lab, radiology, IV, & ancillaries",
    ppc: true,
    typical: false,
  },
  {
    label: "Patient portal to take control of your health",
    ppc: true,
    typical: false,
  },
  {
    label: "5 star rated by insurance companies & 700+ patients",
    ppc: true,
    typical: false,
  },
  { label: "In-house pharmacist available for questions", ppc: true, typical: false },
];

export const insuranceLogos = [
  {
    name: "Humana",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c94d3f2fd6f3bf4e7bfab_Humana.webp",
  },
  {
    name: "Cigna",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c94dfa71e61d28ad1d2c1_Cigna.webp",
  },
  {
    name: "Aetna",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9535eabb4fb714323ff6_Aetna.webp",
  },
  {
    name: "AvMed",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c953e29164c7c7b584068_Avmed.webp",
  },
  {
    name: "Coventry Health Care",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c961f9eced81cfc4966c2_Coventry.webp",
  },
  {
    name: "Florida Blue",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9629452f9cc4b6ebde12_Florida%20Blue.webp",
  },
  {
    name: "United Healthcare",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c964aa71e61d28ad3c71c_United.webp",
  },
  {
    name: "GHI",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9634becf717f24b758ef_GHI.webp",
  },
  {
    name: "Tricare",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c963fb394f11a20e4afaa_Tricare.webp",
  },
  {
    name: "Medicare",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9654f7775d563c6d4f57_Medicare.webp",
  },
];

export const cashPlanArrow =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c969f6f214a1676068151_Blue%20Arrow%20Right.webp";

export const cashPlans = [
  {
    price: "$75",
    suffix: "/Month",
    note: "16-21 years (with Guardian Member)",
    percent: false,
  },
  {
    price: "$150",
    suffix: "/Month",
    note: "Premium Plan DPC Membership",
    percent: false,
  },
  {
    price: "10",
    suffix: "%",
    note: "Only For Couples",
    percent: true,
  },
];

export const awards = [
  {
    name: "award 1",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64e65a8abc761c52e4f743af_1.webp",
  },
  {
    name: "award 2",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64e65a9b631e86385a3174e1_2.webp",
  },
  {
    name: "award 3",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64e65aab5836d4c54034a88e_3.webp",
  },
  {
    name: "award 4",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64e65b31bc761c52e4f7f584_4.webp",
  },
];

export const stethoscopeIcon =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9971a71e61d28ad7ce3c_Stethoscope%20Icon.webp";

export const doctorIllustration =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c98cceabb4fb71438e93e_Doc%20Illustration.webp";

export const mapImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c9a6ff7775d563c725f28_Map.webp";

export const providers: Provider[] = [
  {
    firstName: "Dr. David",
    lastName: "Neuman",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64dcd642c61e102ffd6b54d2_David%20Neuman.webp",
    href: "#providers",
  },
  {
    firstName: "Dr. Danielle",
    lastName: "Neuman",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64dcd61ceab56c0d259bbf25_Danielle%20Neuman.webp",
    href: "#providers",
  },
  {
    firstName: "Dr. William A.",
    lastName: "Shapse",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64c944cdb4a7949cd365fb4f_Shapse.webp",
    href: "#providers",
  },
  {
    firstName: "Liana",
    lastName: "Barkan",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/6a50d2a18009ac0d59c85369_Screen%20Shot%202026-07-10%20at%202.08.05%20PM.png",
    href: "#providers",
  },
  {
    firstName: "Dr. Richard",
    lastName: "Seidelman",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64cbe56cac4f18f5f1ec4349_Seidelman.webp",
    href: "#providers",
  },
  {
    firstName: "Dr. Bennett",
    lastName: "Lewis",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/68dd27bad6792766c8a63e53_IMG_1601.jpeg",
    href: "#providers",
  },
  {
    firstName: "Shoshana",
    lastName: "Kassorla",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/68e808a28bd62b605f2df897_Screen%20Shot%202025-10-09%20at%203.10.03%20PM.png",
    href: "#providers",
  },
  {
    firstName: "Orly",
    lastName: "Matheson",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/6722818338878a5cc6abf60a_Screen%20Shot%202024-10-30%20at%202.56.18%20PM.png",
    href: "#providers",
  },
  {
    firstName: "Dr. Margarita",
    lastName: "Kogan",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/682cc28fef71cdb25a3373ae_Screen%20Shot%202025-05-20%20at%201.57.04%20PM.png",
    href: "#providers",
  },
  {
    firstName: "Regitha",
    lastName: "Sebastian",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64d3da966ada3841a98715ca_Sebastian.webp",
    href: "#providers",
  },
  {
    firstName: "Oliver",
    lastName: "Le Gloahec",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64c944e551b4fe810dfe49b2_Oliver.webp",
    href: "#providers",
  },
  {
    firstName: "Renee",
    lastName: "Jones",
    credential: "M.D.",
    image:
      "https://cdn.prod.website-files.com/648ccb665d482e82f0dff226/64d3daa6421ee122909c1d59_Jones.webp",
    href: "#providers",
  },
];

export const reviews: ReviewItem[] = [
  {
    name: "Carolyn Armstrong",
    date: "11 days ago",
    text: "Very personal and comforting. I like Dr. Orly very much and my PA Felicia and Dr. Neumann — I feel they are really helping me.",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa-%2FALV-UjVfzrK-d67OeVbEM7FqeCYqR02CSVuDuAGM4jt0pyUVb6URnjWQ%3Ds120-c-rp-mo-br100",
  },
  {
    name: "Fred Steigman",
    date: "26 days ago",
    text: "Dr. Baiza was very thorough and thoughtfully explained my iron deficiency issue, and was informative regarding my fingers and heel neuropathy issue.",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa-%2FALV-UjW2a6A07T1hsVQB2xQsb8BhRwWEc6SzkmhYmUArKyK7oHF8XemY6A%3Ds120-c-rp-mo-br100",
  },
  {
    name: "j green",
    date: "1 month ago",
    text: "I've been coming here for several years, and these are some great people to deal with for medical care.",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa%2FACg8ocKMdY2kvdZU7CgU4gZQCJXHecEsQpRsOd5w62cE5hite02bpA%3Ds120-c-rp-mo-ba12-br100",
  },
  {
    name: "mikki freidkin",
    date: "1 month ago",
    text: "I just moved from out of state to Florida and hurt my finger! Someone in my building recommended Olivier Le Gloahec. I received excellent care and now I'm looking forward to seeing a primary care doctor at Personal Physician Care for my annual physical.",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa%2FACg8ocIyc_yZpSrQHGAxw-hDwOK_QXjzSLhBBBap7ix4nMKx7i58a4w%3Ds120-c-rp-mo-ba12-br100",
  },
  {
    name: "Teresa Riechers",
    date: "1 month ago",
    text: "Dr. Jones cares about her patients, she is well known, answers right away your inquiries; I am happy with the whole crew!!",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa%2FACg8ocKCn-sfmMc51y2SLA0LRR_ytM-L3SFXbvJm7jMQYQ-LAOIy%3Ds120-c-rp-mo-br100",
  },
  {
    name: "Phillip Rich",
    date: "1 month ago",
    text: "Great staff and Provider. They seem very proficient in the field they are in.",
    avatar:
      "https://phosphor.utils.elfsightcdn.com/?url=https%3A%2F%2Flh3.googleusercontent.com%2Fa%2FACg8ocJ03drL8MMAVHfEDGf1yXmwyB-CyFAp0Yq8XIyIqA5uejHXKw%3Ds120-c-rp-mo-ba12-br100",
  },
];

export const resources: ResourceItem[] = [
  {
    title: "Prescription Refill Right When You Need It",
    text: "Experience timely prescription refills for uninterrupted access to medications, promoting adherence, prioritizing your health and wellness.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca17c34a1fb62a8d95f85_Resources%201.webp",
    ctaLabel: "Coming Soon",
    ctaHref: "#resources",
  },
  {
    title: "New Patient Information Form",
    text: "Simplify and streamline your new patient experience: fill forms online at home, save time during the office visit, smooth registration.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca17be2e4d710975276e9_Resources%202.webp",
    ctaLabel: "Coming Soon",
    ctaHref: "#resources",
  },
  {
    title: "In-House Shop for Your Convenience",
    text: "Explore our curated selection of IV packages and holistic supplements, expertly recommended by our doctors to enhance your health.",
    image:
      "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/64cd5d9e922b0e01986eaa4a_Shop.webp",
    ctaLabel: "Read More",
    ctaHref: "#shop",
  },
];

export const offersImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca28e28ef368d3ab65305_Offers.webp";

export const insurancePromoImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca339dc815f33b0e26af6_Insurance.webp";

export const faqsLeft: FaqItem[] = [
  {
    question: "What services does your medical practice offer?",
    answer:
      "We offer a comprehensive range of medical services, including general check-ups, preventive care, vaccinations, chronic disease management, minor procedures, and much more. Please visit our Services page on our website for a detailed list.",
  },
  {
    question: "What are your office hours?",
    answer:
      "Our office hours vary based on location, as not all our locations offer after hours. You can view each location's hours by clicking on the Locations tab and choosing the location page you wish to see the hours for.",
  },
  {
    question: "What forms of payment do you accept?",
    answer:
      "We accept many different insurance plans, cash, credit cards, and debit cards. For more information about accepted payment methods, please refer to our Insurance page.",
  },
  {
    question: "Can I download patient forms from your website?",
    answer:
      "Yes, you can download patient forms directly from our website. We have a Forms page where you can find and print the necessary forms to fill out before your appointment in order to streamline the process.",
  },
  {
    question: "Are you accepting new patients?",
    answer:
      "Yes, we are currently accepting new patients. We would be delighted to welcome you to our medical practice. Please schedule an appointment with us.",
  },
  {
    question: "How can I access my medical records?",
    answer:
      "You can access your medical records through our secure patient portal. If you haven't registered for the portal yet, please let our staff know, and they will guide you through the process.",
  },
  {
    question: "Can I bring a family member with me to my appointment?",
    answer:
      "Absolutely, you are welcome to bring a family member or friend with you to your appointment for support or assistance.",
  },
];

export const faqsRight: FaqItem[] = [
  {
    question: "How can I schedule an appointment?",
    answer:
      "To schedule an appointment, you can use our convenient online booking system through our patient portal. Alternatively, you can call our office during business hours, and our friendly staff will be happy to assist you.",
  },
  {
    question: "Do you accept insurance?",
    answer:
      "Yes, we accept a wide range of insurance plans. To check if we accept your insurance, please visit our Insurance page or feel free to give our office a call.",
  },
  {
    question: "Is there parking available at your facility?",
    answer:
      "Yes, we provide ample parking for our patients at our facility. There is also accessible parking available for those with mobility needs.",
  },
  {
    question: "How do I request a prescription refill?",
    answer:
      "You can request a prescription refill by calling our office during business hours or by using our online patient portal. If you are using the patient portal, please allow up to 24 hours for processing.",
  },
  {
    question: "Do you offer tele-medicine appointments?",
    answer:
      "Yes, we do offer tele-medicine appointments for certain medical conditions. Please contact our office to check if your condition is suitable for a tele-medicine visit.",
  },
  {
    question: "Do you offer translation for non-English-speaking patients?",
    answer:
      "Yes, we provide translation services for patients who do not speak English. Please inform us of your language preference when scheduling your appointment, so we can make necessary arrangements.",
  },
  {
    question: "How can I provide feedback about my experience?",
    answer:
      "We value feedback from our patients. You can provide feedback through our website's Contact page or by speaking directly with our staff.",
  },
];

export const logoImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648c68f7c498859c7f13f182_personal-physician-new-logo.png";

export const heroLogoImage =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/6491c1a8958b7e1ee7c19a85_Mobile%20Logo%20With%20Heading.webp";

export const footerLogo =
  "https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca48e400e18de23680c91_Logo%20Footer.webp";

export const contactInfo = {
  phone: "(561) 483-5224",
  email: "info@pphysiciancare.com",
  hours: "Mon – Fri: 8:30 AM – 5:00 PM",
  cities: ["Boca Raton", "Delray Beach", "Hallandale Beach"],
};

export const formLocationOptions = ["Boca Raton", "Delray Beach", "Hallandale Beach"];

export interface LocationHour {
  days: string;
  time: string;
}

export interface LocationItem {
  city: string;
  image: string;
  addressLines: string[];
  phone: string;
  phoneHref: string;
  directionsHref: string;
  hours: LocationHour[];
}

export const locations: LocationItem[] = [
  {
    city: "Hallandale Beach",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20medical%20examination%20room%20with%20white%20walls%2C%20a%20light%20grey%20exam%20chair%2C%20a%20sleek%20white%20desk%20with%20a%20laptop%2C%20a%20blue%20accent%20chair%2C%20large%20windows%20with%20soft%20natural%20daylight%2C%20clean%20minimalist%20clinic%20interior%2C%20editorial%20architecture%20photography%2C%20airy%20light%20neutral%20tones&width=800&height=360&seq=loc-hallandale-01&orientation=landscape",
    addressLines: ["2100 E Hallandale Beach Blvd, Unit 307,", "Hallandale Beach, FL 33486"],
    phone: "(954) 454 - 9055",
    phoneHref: "tel:9544549055",
    directionsHref:
      "https://www.google.com/maps/search/?api=1&query=2100+E+Hallandale+Beach+Blvd+Unit+307+Hallandale+Beach+FL+33486",
    hours: [
      { days: "Mon - Fri:", time: "9:00 AM - 5:00 PM" },
      { days: "Sat & Sun:", time: "Closed" },
    ],
  },
  {
    city: "Delray Beach",
    image:
      "https://readdy.ai/api/search-image?query=Spacious%20bright%20medical%20waiting%20area%20with%20several%20tables%20and%20chairs%2C%20glossy%20wood%20floor%2C%20green%20plants%2C%20a%20wall%20mounted%20television%2C%20abundant%20ceiling%20lighting%2C%20wide%20open%20modern%20clinic%20interior%2C%20editorial%20architecture%20photography%2C%20warm%20neutral%20tones&width=800&height=360&seq=loc-delray-01&orientation=landscape",
    addressLines: ["4800 Linton Blvd, Unit F-107,", "Delray Beach, FL 33445"],
    phone: "(228) 215-7625",
    phoneHref: "tel:2282157625",
    directionsHref:
      "https://www.google.com/maps/search/?api=1&query=4800+Linton+Blvd+Unit+F-107+Delray+Beach+FL+33445",
    hours: [
      { days: "Mon - Wed:", time: "8:00 AM - 7:00 PM" },
      { days: "Thu & Fri:", time: "8:00 AM - 5:00 PM" },
      { days: "Sat:", time: "9:00 AM - 2:00 PM" },
    ],
  },
  {
    city: "Boca Raton",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20minimalist%20clinic%20room%20with%20a%20white%20exam%20table%2C%20a%20white%20drawer%20cabinet%2C%20a%20computer%20desk%20with%20a%20chair%2C%20potted%20plant%2C%20striped%20window%20blinds%20with%20soft%20daylight%2C%20clean%20modern%20medical%20interior%2C%20editorial%20architecture%20photography%2C%20light%20neutral%20tones&width=800&height=360&seq=loc-boca-01&orientation=landscape",
    addressLines: ["951 NW 13th Street, Unit 1B,", "Boca Raton, FL 33486"],
    phone: "(561) 750-7509",
    phoneHref: "tel:5617507509",
    directionsHref:
      "https://www.google.com/maps/search/?api=1&query=951+NW+13th+Street+Unit+1B+Boca+Raton+FL+33486",
    hours: [
      { days: "Mon - Fri:", time: "8:30 AM - 5:00 PM" },
      { days: "Sat & Sun:", time: "Closed" },
    ],
  },
];